import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { Button } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { editUserAttribute } from 'lib/api'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const FreeTierPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { user, setUser, fetchUser } = useUser()

  const [checked, setChecked] = useState(false)

  const sendConsent = async () => {
    await editUserAttribute(true, 'consentedToBranding')
    setUser((user) => ({ ...user, consentedToBranding: true }))
    await fetchUser()
  }

  return (
    <div className="p-2">
      <h4 className="mb-3">{t('misc.noActiveSubscription')}</h4>

      <span>&bull; {t('freeTier.noLonger')}</span>
      <br />
      <span>&bull; {t('freeTier.maxArticles')}</span>

      {!user.consentedToBranding && (
        <div className="mt-3">
          <Box margin="0 auto" width="fit-content">
            <Box display={'flex'} alignItems={'center'}>
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="publish-changes-checkbox"
                    onChange={() => setChecked(!checked)}
                    name="checkedB"
                    checked={checked}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body2" align={'left'}>
                    {t('freeTier.confirm')}
                  </Typography>
                }
              />
            </Box>
          </Box>
          <div className="w-100 text-center mt-4">
            <Button onClick={sendConsent} disabled={!checked} color="primary" variant="outlined">
              {t('freeTier.continue')}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
